<script setup>
/**
 * A CASCA dos painéis das ações em massa (etiquetas, status, responsável,
 * time).
 *
 * Os quatro eram escritos à mão, cada um com o seu cabeçalho, o seu X, o seu
 * triângulo apontando para o botão (com a posição cravada em rem por painel)
 * e o seu vidro `bg-n-alpha-3`. O triângulo saiu: o botão que abriu o painel
 * fica ACESO, e é isso que diz de onde ele veio.
 */
import { vOnClickOutside } from '@vueuse/components';
import { useI18n } from 'vue-i18n';

defineProps({
  titulo: { type: String, required: true },
});

const emit = defineEmits(['close']);
const { t } = useI18n();

const fechar = () => emit('close');

// Os botões que ABREM os painéis ficam fora deles e levam `data-bka`: sem o
// `ignore`, clicar no botão do painel aberto fechava pelo clique-fora e
// reabria pelo próprio clique.
const clicarFora = [fechar, { ignore: ['[data-bka]'] }];
</script>

<template>
  <div
    v-on-click-outside="clicarFora"
    class="advup-menu advup-pop bpo"
    role="dialog"
    :aria-label="titulo"
    @keydown.esc.stop="fechar"
  >
    <div class="bpo__topo">
      <p class="advup-rotulo advup-rotulo--secao bpo__tit">{{ titulo }}</p>
      <button
        type="button"
        class="advup-acao advup-acao--p"
        :aria-label="t('BULK_ACTION.CLOSE')"
        @click="fechar"
      >
        <i class="i-lucide-x" />
      </button>
    </div>
    <slot />
  </div>
</template>

<style scoped>
.bpo {
  position: absolute;
  z-index: 30;
  top: calc(100% - var(--esp-1));
  inset-inline-end: var(--esp-2);
  display: flex;
  flex-direction: column;
  width: min(18rem, calc(100% - var(--esp-4)));
  max-height: 22rem;
}

.bpo__topo {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  gap: var(--esp-2);
  padding: var(--esp-1) var(--esp-1) var(--esp-1) var(--esp-3);
}

.bpo__tit {
  margin: 0;
}
</style>
